import { useLoginServerAuto } from "@hooks/selectors/game.selectors";
import { Text } from '@constructor/components';
import {FC} from "react";

interface LoginServerNameProps {
    login_id?: string | number;
}

const LoginServerName: FC<LoginServerNameProps> = ({ login_id, ...props }) => {

    const loginServer = useLoginServerAuto(login_id);
    if(!loginServer?.name) {
        return null;
    }

    return (
        <Text text={loginServer.name} {...props}></Text>
    )
}

export default LoginServerName;